/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PersonAutocompleteComponent } from './person-autocomplete/person-autocomplete.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from "@ngx-translate/core";
import { SharedComponentsModule } from "@well/shared-components";
import { FloatLabel } from 'primeng/floatlabel';
import {
  BsAutocompleteComponent,
  BsItemDirective,
  BsFloatLabelCompatDirective
} from 'iriro-frontend-libs/bs-component-store';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    SharedComponentsModule,
    FloatLabel,
    BsAutocompleteComponent,
    BsItemDirective,
    BsFloatLabelCompatDirective
  ],
  declarations: [PersonAutocompleteComponent],
  exports: [PersonAutocompleteComponent]
})
export class PersonAutocompleteModule {

}
